// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D4-V","right":"styles_right__2QwUS"};